{
  "PROFILE_SETTINGS": {
    "LINK": "Profila Iestatījumi",
    "TITLE": "Profila Iestatījumi",
    "BTN_TEXT": "Atjaunināt Profilu",
    "DELETE_AVATAR": "Dzēst Avatāru",
    "AVATAR_DELETE_SUCCESS": "Avatārs ir veiksmīgi izdzēsts",
    "AVATAR_DELETE_FAILED": "Avatāra dzēšanas laikā radās kļūda. Lūdzu, mēģiniet vēlreiz",
    "UPDATE_SUCCESS": "Jūsu profils ir veiksmīgi atjaunināts",
    "PASSWORD_UPDATE_SUCCESS": "Jūsu parole ir veiksmīgi nomainīta",
    "AFTER_EMAIL_CHANGED": "Jūsu profils ir veiksmīgi atjaunināts. Lūdzu, atkārtoti pierakstieties, jo Jūsu akreditācijas dati ir mainīti",
    "FORM": {
      "PICTURE": "Profila Attēls",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "E-pasta paraksta attēls",
        "HINT": "Izmanto e-pasta parakstos. {'{{'}email_signature_picture{'}}'} tiek aizstāts ar šī attēla URL adresi (nevis img birku) — izmantojiet to kā attēla avotu (img birkas src atribūtu) savā parakstā vai iesūtnes parakstā. Ja nav iestatīts, nekas netiek ievietots.",
        "DELETE_SUCCESS": "E-pasta paraksta attēls ir veiksmīgi izdzēsts",
        "DELETE_FAILED": "Dzēšot e-pasta paraksta attēlu, radās kļūda, lūdzu, mēģiniet vēlreiz"
      },
      "AVATAR": "Profila Attēls",
      "ERROR": "Lūdzu, izlabojiet veidlapas kļūdas",
      "REMOVE_IMAGE": "Noņemt",
      "UPLOAD_IMAGE": "Augšupielādēt attēlu",
      "UPDATE_IMAGE": "Atjaunināt attēlu",
      "PROFILE_SECTION": {
        "TITLE": "Profils",
        "NOTE": "Jūsu e -pasta adrese ir jūsu identitāte, un to izmanto lai pierakstītos."
      },
      "SEND_MESSAGE": {
        "TITLE": "Karstais taustiņš ziņojumu sūtīšanai",
        "NOTE": "Jūs varat izvēlēties karsto taustiņu (vai nu Enter, vai Cmd/Ctrl+Enter), pamatojoties uz Jūsu rakstības ieradumiem.",
        "UPDATE_SUCCESS": "Jūsu iestatījumi ir veiksmīgi atjaunināti",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Sūtīt ziņojumus, nospiežot taustiņu Enter, nevis noklikšķinot uz pogas Sūtīt."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Sūtīt ziņojumus, nospiežot taustiņu Cmd/Ctrl + Enter, nevis noklikšķinot uz pogas Sūtīt."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interfeiss",
        "NOTE": "Pielāgot sava informācijas paneļa izskatu un darbību.",
        "FONT_SIZE": {
          "TITLE": "Fonta lielums",
          "NOTE": "Pielāgot teksta lielumu informācijas panelī, atbilstoši savām vēlmēm.",
          "UPDATE_SUCCESS": "Fonta iestatījumi ir veiksmīgi atjaunināti",
          "UPDATE_ERROR": "Atjauninot fonta iestatījumus radās kļūda. Lūdzu, mēģiniet vēlreiz",
          "OPTIONS": {
            "SMALLER": "Mazāks",
            "SMALL": "Mazs",
            "DEFAULT": "Noklusējums",
            "LARGE": "Liels",
            "LARGER": "Lielāks",
            "EXTRA_LARGE": "Īpaši Liels"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Informācijas paneļa valoda",
          "NOTE": "Aizstājiet konta valodu savam informācijas panelim. Atstājiet tukšu, lai izmantotu konta noklusējuma valodu.",
          "USE_ACCOUNT_DEFAULT": "Izmantot konta noklusējumu",
          "API_SUCCESS": "Jūsu informācijas paneļa valoda ir veiksmīgi atjaunināta"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Ziņojuma valoda",
          "NOTE": "Izvēlieties, vai rādīt oriģinālos ziņojumus vai to tulkojumus",
          "ORIGINAL": "Oriģināls",
          "TRANSLATED": "Iztulkots"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Ielīmēšanas Uzvedība",
          "NOTE": "Izvēlieties, kā apstrādāt ielīmēto saturu, rakstot ziņojumus",
          "UPDATE_SUCCESS": "Jūsu ielīmēšanas iestatījumi ir veiksmīgi atjaunināti",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Saglabāt visu formatējumu",
              "DESCRIPTION": "Ielīmējot saturu, saglabāt visu formatējumu, tostarp tabulas, stilus un citus HTML elementus."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Tikai teksts ar saitēm",
              "DESCRIPTION": "Ielīmējot saturu, pārvērst to vienkāršā tekstā, saglabājot noklikšķināmas saites."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Tikai vienkāršs teksts",
              "DESCRIPTION": "Ielīmējot saturu, noņemt visu formatējumu un pārvērst to vienkāršā tekstā."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Atbildes lauka augstums",
          "NOTE": "Iestatiet atbildes lauka minimālo augstumu kā procentuālu daļu no ekrāna augstuma. Attiecas tikai uz e-pasta sarunām.",
          "UPDATE_SUCCESS": "Jūsu atbildes lauka augstuma iestatījums ir veiksmīgi atjaunināts",
          "PERCENT_LABEL": "Augstums (% no ekrāna augstuma)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Noklusējums",
              "DESCRIPTION": "Atbildes lauks sākotnēji ir mazs un palielinās, rakstot."
            },
            "CUSTOM": {
              "HEADING": "Pielāgots",
              "DESCRIPTION": "Atbildes lauks vienmēr aizņem vismaz izvēlēto procentuālo daļu no ekrāna augstuma."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Automātiski pāriet uz nākamo sarunu",
        "NOTE": "Automātiski pāriet uz nākamo atvērto sarunu pēc pašreizējās atrisināšanas",
        "UPDATE_SUCCESS": "Automātiskās pārejas iestatījums ir veiksmīgi atjaunināts"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Personīgais ziņojuma paraksts",
        "DESCRIPTION": "Izveidojiet unikālu ziņojuma parakstu, kas parādīsies katra Jūsu nosūtītā e-pasta beigās. Varat pievienot arī iekļautu attēlu.",
        "NOTE": "Izveidot unikālu ziņojuma parakstu, kas parādās katra ziņojuma beigās, kuru sūtāt no jebkuras iesūtnes. Varat arī iekļaut attēlu, kas tiek atbalstīts tiešraidē, e-pastā un API iesūtnēs.",
        "BTN_TEXT": "Saglabāt ziņojuma parakstu",
        "API_ERROR": "Nevarēja saglabāt parakstu! Lūdzu, mēģiniet vēlreiz",
        "API_SUCCESS": "Paraksts ir veiksmīgi saglabāts",
        "IMAGE_UPLOAD_ERROR": "Nevarēja augšupielādēt attēlu! Lūdzu, mēģiniet vēlreiz",
        "IMAGE_UPLOAD_SUCCESS": "Attēls ir veiksmīgi pievienots. Lūdzu, noklikšķiniet uz saglabāt, lai saglabātu parakstu",
        "IMAGE_UPLOAD_SIZE_ERROR": "Attēla izmēram ir jābūt mazākam par {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Ziņojuma Paraksts",
        "ERROR": "Ziņojuma Paraksts nevar būt tukšs",
        "PLACEHOLDER": "Ievietojiet savu personīgo ziņojumu parakstu šeit."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Parole",
        "NOTE": "Paroles atjaunināšana varētu atiestatīt jūsu pierakstīšanos vairākās ierīcēs.",
        "BTN_TEXT": "Mainīt paroli"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Piekļuves Token",
        "NOTE": "Šo token var izmantot, ja veidojat uz API balstītu integrāciju",
        "COPY": "Kopēt",
        "REGENERATE": "Ģenerēt no jauna",
        "REGENERATE_SUCCESS": "Piekļuves token veiksmīgi ģenerēts no jauna. Lūdzu, atjauniniet visas integrācijas, kas izmanto veco token.",
        "REGENERATE_CONFIRM_TITLE": "Ģenerēt piekļuves token no jauna?",
        "REGENERATE_CONFIRM_MESSAGE": "Tas padarīs pašreizējo token nederīgu. Visas integrācijas, kas izmanto veco token, pārstās darboties."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome Paplašinājums",
        "NOTE": "Instalējiet mūsu Chrome paplašinājumu, lai saņemtu detalizētus paziņojumus par ienākošajiem zvaniem.",
        "INSTALL_BUTTON": "Instalēt paplašinājumu",
        "ALREADY_INSTALLED": "Paplašinājums instalēts"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Brīdinājumi",
        "NOTE": "Ieslēgt audio brīdinājumus informācijas panelī, priekš jauniem ziņojumiem un sarunām.",
        "PLAY": "Atskaņot skaņu",
        "ALERT_TYPES": {
          "NONE": "Nav",
          "MINE": "Piešķirts",
          "ALL": "Visi",
          "ASSIGNED": "Man piešķirtās sarunas",
          "UNASSIGNED": "Nepiešķirtās sarunas",
          "NOTME": "Atvērt citiem piešķirtās sarunas"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Jūs neesat izvēlējies nevienu opciju, jūs nesaņemsiet audio brīdinājumus.",
          "ASSIGNED": "Jūs saņemsiet brīdinājumus par jums piešķirtajām sarunām.",
          "UNASSIGNED": "Jūs saņemsiet brīdinājumus par nepiešķirtām sarunām.",
          "NOTME": "Jūs saņemsiet brīdinājumus par sarunām, kas piešķirtas citiem.",
          "ASSIGNED+UNASSIGNED": "Jūs saņemsiet brīdinājumus par piešķirtajām sarunām un visām bez uzraudzības atstātām sarunām.",
          "ASSIGNED+NOTME": "Jūs saņemsiet brīdinājumus par sarunām, kas piešķirtas jums un citiem, bet ne par sarunām, kas nav piešķirtas.",
          "NOTME+UNASSIGNED": "Jūs saņemsiet brīdinājumus par sarunām, kas ir bez uzraudzības, kā arī par sarunām, kas piešķirtas citiem.",
          "ASSIGNED+NOTME+UNASSIGNED": "Jūs saņemsiet brīdinājumus par visām sarunām."
        },
        "ALERT_TYPE": {
          "TITLE": "Brīdinājuma notikumi sarunām",
          "NONE": "Nav",
          "ASSIGNED": "Piešķirtās Sarunas",
          "ALL_CONVERSATIONS": "Visas Sarunas"
        },
        "DEFAULT_TONE": {
          "TITLE": "Brīdinājumu signāls:"
        },
        "CONDITIONS": {
          "TITLE": "Brīdinājumu nosacījumi:",
          "CONDITION_ONE": "Sūtīt audio brīdinājumus tikai tad, ja pārlūkprogrammas logs nav aktīvs",
          "CONDITION_TWO": "Sūtīt brīdinājumus ik pēc 30 sekundēm, līdz visas piešķirtās sarunas ir izlasītas"
        },
        "SOUND_PERMISSION_ERROR": "Automātiskā atskaņošana jūsu pārlūkprogrammā ir atspējota. Lai automātiski dzirdētu brīdinājumus, pārlūkprogrammas iestatījumos iespējojiet skaņas atļauju vai mijiedarbojieties ar lapu.",
        "READ_MORE": "Lasīt vairāk"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-pasta Ziņojumi",
        "NOTE": "Atjauniniet savas e -pasta paziņojumu preferences šeit",
        "CONVERSATION_ASSIGNMENT": "Nosūtīt e -pasta paziņojumus, kad man tiek piešķirta saruna",
        "CONVERSATION_CREATION": "Nosūtīt e -pasta paziņojumus, kad tiek izveidota jauna saruna",
        "CONVERSATION_MENTION": "Nosūtīt e -pasta paziņojumus, kad tiekat pieminēts sarunā",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nosūtīt e -pasta paziņojumus, kad piešķirtā sarunā tiek izveidots jauns ziņojums",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Sūtīt e-pasta paziņojumus, kad sarunā tiek izveidots jauns ziņojums",
        "SLA_MISSED_FIRST_RESPONSE": "Nosūtīt e-pasta paziņojumus, ja sarunā tiek nokavēts pirmās atbildes SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Nosūtīt e-pasta paziņojumus, ja sarunā tiek nokavēts nākamās atbildes SLA",
        "SLA_MISSED_RESOLUTION": "Nosūtīt e-pasta paziņojumus, ja sarunā tiek nokavēts atrisināšanas SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Paziņojumu preferences",
        "TYPE_TITLE": "Paziņojuma veids",
        "EMAIL": "E-pasts",
        "PUSH": "Push paziņojums",
        "TYPES": {
          "CONVERSATION_CREATED": "Tiek izveidota jauna saruna",
          "CONVERSATION_ASSIGNED": "Jums ir piešķirta saruna",
          "CONVERSATION_MENTION": "Jūs esat pieminēts sarunā",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Piešķirtajā sarunā ir izveidots jauns ziņojums",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Dalības sarunā ir izveidots jauns ziņojums",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Sarunā bez pieejama aģenta ir izveidots jauns ziņojums",
          "SLA_MISSED_FIRST_RESPONSE": "Sarunā ir nokavēts pirmās atbildes SLA",
          "SLA_MISSED_NEXT_RESPONSE": "Sarunā ir nokavēts nākamās atbildes SLA",
          "SLA_MISSED_RESOLUTION": "Sarunā ir nokavēts atrisināšanas SLA"
        },
        "BROWSER_PERMISSION": "Iespējojiet push paziņojumus savā pārlūkprogrammā, lai varētu tos saņemt",
        "ALLOW_NOTIFICATION_DURING_CALL": "Atļaut push paziņojumus zvana laikā",
        "TEST_PUSH": "Testēt",
        "TESTING": "Notiek testēšana...",
        "TEST_PUSH_DESCRIPTION": "Sūtīt testa paziņojumus, lai pārbaudītu iestatījumus",
        "TEST_NOTIFICATION_ERROR": "Neizdevās nosūtīt testa paziņojumu. Lūdzu, mēģiniet vēlreiz.",
        "TEST_LOCAL_TITLE": "Testa Paziņojums (Lokāls)",
        "TEST_LOCAL_BODY": "Šis ir lokāls pārlūkprogrammas paziņojums. Ja to redzat, pārlūkprogrammas paziņojumi darbojas!"
      },
      "API": {
        "UPDATE_SUCCESS": "Jūsu paziņojumu preferences ir veiksmīgi atjauninātas",
        "UPDATE_ERROR": "Preferenču atjaunināšanas laikā radās kļūda. Lūdzu, mēģiniet vēlreiz"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push Paziņojumi",
        "NOTE": "Atjauniniet savas Push paziņojumu preferences šeit",
        "CONVERSATION_ASSIGNMENT": "Nosūtīt push paziņojumus, kad man tiek piešķirta saruna",
        "CONVERSATION_CREATION": "Nosūtīt push paziņojumus, kad tiek izveidota jauna saruna",
        "CONVERSATION_MENTION": "Nosūtīt push paziņojumus, kad tiekat pieminēts sarunā",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nosūtīt push paziņojumus, kad piešķirtā sarunā tiek izveidots jauns ziņojums",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Sūtīt push paziņojumus, kad sarunā tiek izveidots jauns ziņojums",
        "HAS_ENABLED_PUSH": "Jūs esat iespējojis push šajā pārlūkprogrammā.",
        "REQUEST_PUSH": "Iespējot push paziņojumus",
        "SLA_MISSED_FIRST_RESPONSE": "Nosūtīt push paziņojumus, ja sarunā tiek nokavēts pirmās atbildes SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Nosūtīt push paziņojumus, ja sarunā tiek nokavēts nākamās atbildes SLA",
        "SLA_MISSED_RESOLUTION": "Nosūtīt push paziņojumus, ja sarunā tiek nokavēts atrisināšanas SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profila Attēls"
      },
      "NAME": {
        "LABEL": "Jūsu pilnais vārds",
        "ERROR": "Lūdzu, ievadiet derīgu pilnu vārdu",
        "PLACEHOLDER": "Lūdzu, ievadiet savu pilno vārdu"
      },
      "DISPLAY_NAME": {
        "LABEL": "Parādāmais vārds",
        "ERROR": "Lūdzu, ievadiet derīgu parādāmo vārdu",
        "PLACEHOLDER": "Lūdzu, ievadiet parādāmo vārdu, tas tiks parādīts sarunās"
      },
      "POSITION": {
        "LABEL": "Amats",
        "ERROR": "Lūdzu, ievadiet derīgu amatu",
        "PLACEHOLDER": "Lūdzu, ievadiet savu amatu"
      },
      "CUSTOM_LINE": {
        "LABEL": "Pielāgota rinda",
        "ERROR": "Lūdzu, ievadiet derīgu pielāgoto rindu",
        "PLACEHOLDER": "Lūdzu, ievadiet savu pielāgoto rindu"
      },
      "AVAILABILITY": {
        "LABEL": "Pieejamība",
        "STATUS": {
          "ONLINE": "Tiešsaistē",
          "BUSY": "Aizņemts",
          "OFFLINE": "Bezsaistē"
        },
        "SET_AVAILABILITY_SUCCESS": "Pieejamība ir veiksmīgi iestatīta",
        "SET_AVAILABILITY_ERROR": "Nevarēja iestatīt pieejamību. Lūdzu, mēģiniet vēlreiz"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "E-pasta priekšskatījuma formāts sarunu sarakstā",
        "NOTE": "Izvēlieties, kas tiek rādīts sarunu sarakstā sarunām no e-pasta iesūtnēm",
        "SUBJECT": "Tēma",
        "SUBJECT_WITH_NOTE": "Tēma un pēdējais ziņojums, ja tā ir privāta piezīme",
        "UPDATE_SUCCESS": "E-pasta priekšskatījuma iestatījums ir veiksmīgi atjaunināts"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Atspējot tastatūras īsinājumtaustiņus",
        "NOTE": "Izslēgt visus tastatūras īsinājumtaustiņus visā lietotnē",
        "UPDATE_SUCCESS": "Tastatūras īsinājumtaustiņu iestatījums ir veiksmīgi atjaunināts"
      },
      "FOLDER_ORDER": {
        "TITLE": "Mapju Secība",
        "NOTE": "Pielāgojiet secību, kādā mapes (pielāgotie skati) parādās sānjoslā. Velciet un nometiet, lai mainītu secību.",
        "NO_FOLDERS": "Nav atrasta neviena pielāgota mape. Izveidojiet mapes, lai sakārtotu savas sarunas."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Sānjoslas Konfigurācija",
        "NOTE": "Pielāgojiet, kuras sadaļas parādās sarunu sānjoslā.",
        "SAVE_BUTTON": "Saglabāt Konfigurāciju",
        "UPDATE_SUCCESS": "Sānjoslas konfigurācija ir veiksmīgi atjaunināta",
        "UPDATE_ERROR": "Atjauninot sānjoslas konfigurāciju, radās kļūda, lūdzu, mēģiniet vēlreiz",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Visas Sarunas",
          "ALL_CONVERSATIONS_DESC": "Rādīt izvēlnes vienumu \"Visas Sarunas\" sānjoslā",
          "INBOX": "Iesūtne",
          "INBOX_DESC": "Rādīt galveno iesūtni ar nelasītiem paziņojumiem",
          "CONVERSATION_GROUPS": "Pieminēšanas un Bez Uzraudzības",
          "CONVERSATION_GROUPS_DESC": "Rādīt sarunu grupas Pieminēšanas un Bez uzraudzības",
          "FOLDERS": "Mapes",
          "FOLDERS_DESC": "Rādīt pielāgotos skatus (mapes) sakārtotām sarunām",
          "TEAMS": "Komandas",
          "TEAMS_DESC": "Rādīt sarunas, filtrētas pēc komandas piešķīruma",
          "CHANNELS": "Iesūtnes",
          "CHANNELS_DESC": "Rādīt sarunas, filtrētas pēc iesūtnes",
          "LABELS": "Etiķetes",
          "LABELS_DESC": "Rādīt sarunas, filtrētas pēc etiķetēm"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Tālruņa iestatījumi",
        "NOTE": "Ievadiet pieteikšanās datus savai PBX sistēmai.",
        "USERNAME": "Lietotājvārds",
        "PASSWORD": "Parole",
        "SUBMIT": "Saglabāt",
        "USERNAME_INVALID": "Lietotājvārds var saturēt tikai burtus, ciparus un . _ - + — bez atstarpēm un bez e-pasta adreses.",
        "API": {
          "USERNAME_INVALID": "Lietotājvārds nav derīgs SIP lietotājvārds. Izmantojiet tikai burtus, ciparus un . _ - + — bez atstarpēm un bez e-pasta adreses.",
          "USERNAME_TAKEN": "Šo lietotājvārdu jau izmanto cits šī konta aģents."
        }
      },
      "EMAIL": {
        "LABEL": "Jūsu e-pasta adrese",
        "ERROR": "Lūdzu, ievadiet derīgu e-pasta adresi",
        "PLACEHOLDER": "Lūdzu, ievadiet savu e-pasta adresi, tā tiks parādīta sarunās"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Pašreizējā parole",
        "ERROR": "Lūdzu, ievadiet pašreizējo paroli",
        "PLACEHOLDER": "Lūdzu, ievadiet pašreizējo paroli"
      },
      "PASSWORD": {
        "LABEL": "Jauna parole",
        "ERROR": "Lūdzu, ievadiet paroli, kuras garums ir 6 vai vairāk simboli",
        "PLACEHOLDER": "Lūdzu, ievadiet jauno paroli"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Apstipriniet jauno paroli",
        "ERROR": "Apstiprinājuma parolei ir jāsakrīt ar paroli",
        "PLACEHOLDER": "Lūdzu, vēlreiz ievadiet savu jauno paroli"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Mainīt",
    "CHANGE_ACCOUNTS": "Pārslēgt kontu",
    "SWITCH_ACCOUNT": "Pārslēgt kontu",
    "CONTACT_SUPPORT": "Sazināties ar atbalstu",
    "REPORT_BUG": "Ziņot par kļūdu",
    "SELECTOR_SUBTITLE": "Izvēlieties kontu no šī saraksta",
    "PROFILE_SETTINGS": "Profila iestatījumi",
    "KEYBOARD_SHORTCUTS": "Tastatūras īsinājumtaustiņi",
    "APPEARANCE": "Mainīt izskatu",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin konsole",
    "DOCS": "Lasīt dokumentāciju",
    "LOGOUT": "Izrakstīties"
  },
  "BUG_REPORT": {
    "TITLE": "Ziņot par kļūdu",
    "DESCRIPTION_LABEL": "Problēmas Apraksts",
    "DESCRIPTION_PLACEHOLDER": "Aprakstiet problēmu, ar kuru saskārāties...",
    "SUBMIT": "Iesniegt ziņojumu",
    "SUBMITTING": "Notiek iesniegšana...",
    "CANCEL": "Atcelt",
    "SUCCESS": "Kļūdas ziņojums veiksmīgi iesniegts. Paldies!",
    "VALIDATION_ERROR": "Lūdzu, aprakstiet problēmu pirms iesniegšanas"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "izmēģinājuma dienas atlikušas.",
    "TRAIL_BUTTON": "Pirkt Tagad",
    "DELETED_USER": "Dzēsts Lietotājs",
    "EMAIL_VERIFICATION_PENDING": "Izskatās, ka Jūs vēl neesat verificējis savu e-pasta adresi. Lūdzu, izlasiet savā iesūtnē verifikācijas e-pasta ziņojumu.",
    "RESEND_VERIFICATION_MAIL": "Sūtīt verifikācijas e-pastu atkārtoti",
    "EMAIL_VERIFICATION_SENT": "Verifikācijas e-pasts ir nosūtīts. Lūdzu, pārbaudiet savu iesūtni.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Konts Iesaldēts",
      "MESSAGE": "Jūsu konts ir iesaldēts. Lai iegūtu papildu informāciju, lūdzu, sazinieties ar atbalsta komandu."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopēt",
      "CODEPEN": "Atvērt programmā CodePen",
      "COPY_SUCCESSFUL": "Kopēts starpliktuvē"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Parādīt Vairāk",
      "SHOW_LESS": "Parādīt Mazāk"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Lejupielādēt",
      "UPLOADING": "Notiek augšupielāde...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Šis stāsts vairs nav pieejams.",
      "RECORDING_UNAVAILABLE": "Šis ieraksts vairs nav pieejams.",
      "DELETE_RECORDING": {
        "BUTTON": "Dzēst zvana ierakstu",
        "TITLE": "Vai dzēst zvana ierakstu?",
        "DESCRIPTION": "Visi šī zvana ieraksti tiks neatgriezeniski dzēsti no tālruņu sistēmas, un tos nevarēs atjaunot. Zvana transkripcija un kopsavilkums saglabāsies.",
        "CONFIRM": "Dzēst",
        "SUCCESS": "Zvana ieraksts dzēsts",
        "ERROR": "Neizdevās dzēst zvana ierakstu. Lūdzu, mēģiniet vēlreiz."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Skatīt kartē"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Iesniegt"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Šis attēls vairs nav pieejams.",
      "LOADING_FAILED": "Ielāde neizdevās"
    }
  },
  "CONFIRM_EMAIL": "Notiek pārbaude...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Pievienot Iesūtni"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Nav vienumu",
    "CURRENTLY_VIEWING_ACCOUNT": "Pašlaik skatās:",
    "SWITCH": "Pārslēgt",
    "INBOX_VIEW": "Iesūtnes Skats",
    "CONVERSATIONS": "Sarunas",
    "INBOX": "Mana Iesūtne",
    "ALL_CONVERSATIONS": "Visas Sarunas",
    "MENTIONED_CONVERSATIONS": "Pieminēšanas",
    "PARTICIPATING_CONVERSATIONS": "Piedalās",
    "UNATTENDED_CONVERSATIONS": "Bez uzraudzības",
    "REPORTS": "Pārskati",
    "SETTINGS": "Iestatījumi",
    "CONTACTS": "Kontaktpersonas",
    "DATA_ASSISTANT": "Datu asistents",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Asistenti",
    "CAPTAIN_DOCUMENTS": "Dokumenti",
    "CAPTAIN_RESPONSES": "Bieži uzdotie jautājumi",
    "HOME": "Sākums",
    "AGENTS": "Aģenti",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audita Žurnāli",
    "WHATSAPP_TEMPLATES": "WhatsApp Veidnes",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Iesūtnes",
    "NOTIFICATIONS": "Paziņojumi",
    "CANNED_RESPONSES": "Sagatavotās Atbildes",
    "INTEGRATIONS": "Integrācijas",
    "PROFILE_SETTINGS": "Profila Iestatījumi",
    "ACCOUNT_SETTINGS": "Konta Iestatījumi",
    "APPLICATIONS": "Lietojumprogrammas",
    "LABELS": "Etiķetes",
    "CUSTOM_ATTRIBUTES": "Pielāgotas Īpašības",
    "AUTOMATION": "Automatizācija",
    "MACROS": "Macros",
    "TEAMS": "Komandas",
    "BILLING": "Norēķini",
    "CUSTOM_VIEWS_FOLDER": "Mapes",
    "CUSTOM_VIEWS_SEGMENTS": "Segmenti",
    "ALL_CONTACTS": "Visi Kontakti",
    "TAGGED_WITH": "Marķēts ar",
    "NEW_LABEL": "Jauna etiķete",
    "NEW_TEAM": "Jauna komanda",
    "NEW_INBOX": "Jauna iesūtne",
    "REPORTS_CONVERSATION": "Sarunas",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Tiešraides tērzēšana",
    "SMS": "SMS",
    "CAMPAIGNS": "Kampaņas",
    "ONGOING": "Notiekošs",
    "ONE_OFF": "Vienreizējs",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Aģenti",
    "REPORTS_LABEL": "Etiķetes",
    "REPORTS_INBOX": "Iesūtne",
    "REPORTS_TEAM": "Komanda",
    "REPORTS_PHONE": "Tālrunis",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Pārskats",
    "WALLBOARD_QUEUES": "Rindas",
    "DATA_ASSISTANT_CHAT": "Tērzēšana",
    "DATA_ASSISTANT_REPORTS": "Pārskati",
    "NO_WAITING_CALLERS": "neviens zvanītājs negaida",
    "WAITING_CALLERS": "{count} zvanītāji gaida",
    "SET_AVAILABILITY_TITLE": "Iestatīt sevi kā",
    "SET_YOUR_AVAILABILITY": "Iestatīt savu pieejamību",
    "AVAILABILITY_IMPERSONATING": "Bloķēts, kamēr esat pieteicies kā šis lietotājs",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Pielāgotas lomas",
    "NEW_CONVERSATION": "Jauna saruna",
    "DRAFT": "Melnraksts",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Pārskats",
    "REAUTHORIZE": "Jūsu iesūtnes savienojuma termiņš ir beidzies. Lūdzu, pievienojiet vēlreiz\n lai turpinātu saņemt un sūtīt ziņas",
    "HELP_CENTER": {
      "TITLE": "Palīdzības centrs",
      "ARTICLES": "Raksti",
      "CATEGORIES": "Kategorijas",
      "LOCALES": "Lokalizācijas",
      "SETTINGS": "Iestatījumi",
      "DICTIONARY": "Vārdnīca"
    },
    "CHANNELS": "Kanāli",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Automātiski atzīmēt bezsaistē",
      "INFO_TEXT": "Ļaut sistēmai, kad neizmantojat lietotni vai informācijas paneli, automātiski atzīmēt Jūs bezsaistē.",
      "INFO_SHORT": "Automātiski atzīmēt bezsaistē, kad neizmantojat lietotni."
    },
    "DOCS": "Lasīt dokumentus"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Bloķētie domēni un kontaktpersonas",
    "DESCRIPTION": "Šī konta bloķēto e-pasta domēnu saraksts.",
    "NO_BLOCKED_DOMAINS": "Nav atrasts neviens bloķēts domēns.",
    "BLOCKED_CONTACTS_BTN": "Bloķētās Kontaktpersonas"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Norēķini",
    "DESCRIPTION": "Pārvaldiet savu abonementu šeit. Modernizējiet abonementu un iegūstiet papildu funkcijas savai komandai.",
    "CURRENT_PLAN": {
      "TITLE": "Pašreizējais Norēķinu Plāns",
      "PLAN_NOTE": "Šobrīd Jūs abonējat **{plan}** plānu ar **{quantity}** licencēm",
      "SEAT_COUNT": "Lietotāju skaits",
      "RENEWS_ON": "Atjaunojas"
    },
    "VIEW_PRICING": "Skatīt Izcenojumu",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Pārvaldīt savu abonementu",
      "DESCRIPTION": "Apskatīt iepriekšējos rēķinus, rediģēt norēķinu informāciju vai atcelt abonementu.",
      "BUTTON_TXT": "Doties uz norēķinu portālu"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Pārvaldīt Captain AI lietošanu un kredītus.",
      "BUTTON_TXT": "Iegādāties vairāk kredītu",
      "DOCUMENTS": "Dokumenti",
      "RESPONSES": "Atbildes",
      "UPGRADE": "Captain nav pieejams bezmaksas abonementā. Modernizējiet abonementu tūlīt, lai piekļūtu asistentiem un copilot."
    },
    "CHAT_WITH_US": {
      "TITLE": "Nepieciešama palīdzība?",
      "DESCRIPTION": "Vai Jūs saskārāties ar kādām problēmām norēķinu laikā? Mēs esam šeit, lai palīdzētu.",
      "BUTTON_TXT": "Tērzēt ar mums"
    },
    "NO_BILLING_USER": "Jūsu norēķinu konts tiek konfigurēts. Lūdzu, atsvaidziniet lapu un mēģiniet vēlreiz."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ak, vai! Mēs nevarējām atrast nevienu kontu. Lūdzu, izveidojiet jaunu kontu, lai turpinātu.",
    "NEW_ACCOUNT": "Jauns Konts",
    "SELECTOR_SUBTITLE": "Izveidot jaunu kontu",
    "API": {
      "SUCCESS_MESSAGE": "Konts ir veiksmīgi izveidots",
      "EXIST_MESSAGE": "Konts jau pastāv",
      "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Uzņēmuma Nosaukums",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Iesniegt",
      "CANCEL": "Atcelt"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Skatīt visus īsinājumtaustiņus",
    "TITLE": {
      "OPEN_CONVERSATION": "Atvērt sarunu",
      "RESOLVE_AND_NEXT": "Atrisināt un pāriet uz nākamo",
      "NAVIGATE_DROPDOWN": "Pārvietoties starp nolaižamā saraksta vienumiem",
      "RESOLVE_CONVERSATION": "Atrisināt Sarunu",
      "GO_TO_CONVERSATION_DASHBOARD": "Doties uz Sarunu Informācijas Paneli",
      "ADD_ATTACHMENT": "Pievienot Pielikumu",
      "GO_TO_CONTACTS_DASHBOARD": "Doties uz Kontaktu Informācijas Paneli",
      "TOGGLE_SIDEBAR": "Pārslēgt Sānjoslu",
      "GO_TO_REPORTS_SIDEBAR": "Doties uz Pārskatu sānjoslu",
      "MOVE_TO_NEXT_TAB": "Pāriet uz sarunu saraksta nākamo cilni",
      "GO_TO_SETTINGS": "Doties uz Iestatījumiem",
      "SWITCH_TO_PRIVATE_NOTE": "Pārslēgties uz Privāto Piezīmi",
      "SWITCH_TO_REPLY": "Pārslēgties uz Atbildi",
      "TOGGLE_SNOOZE_DROPDOWN": "Pārslēgt atlikšanas nolaižamo izvēlni",
      "AI_ASSIST_MENU": "AI Palīgs",
      "AI_ASSIST_GRAMMAR": "Labot Gramatiku",
      "AI_ASSIST_UNIFY_LANG": "Vienādot Ziņojuma Valodu"
    }
  }
}
